import { createSlice } from '@reduxjs/toolkit';

const configs = createSlice({
    name: 'configs',
    initialState: {
        maintenanceConfig: null,
        maintenanceConfigLoaded: false,
        //
        settingsConfig: null,
        settingsConfigLoaded: false,
    },
    reducers: {
        getMaintenanceConfig() { },
        getSettingsConfig() { },
        setMaintenanceConfig(state, action) {
            const data = action.payload;
            return { ...state, maintenanceConfig: data, maintenanceConfigLoaded: true };
        },
        setSettingsConfig(state, action) {
            const data = action.payload;
            return { ...state, settingsConfig: data, settingsConfigLoaded: true };
        },
        settingsConfigError(state) {
            return { ...state, settingsConfigLoaded: true };
        },
        maintenanceConfigError(state) {
            return { ...state, maintenanceConfigLoaded: true };
        },
    },
});

export const { getMaintenanceConfig, getSettingsConfig, setMaintenanceConfig, setSettingsConfig, settingsConfigError, maintenanceConfigError } =
    configs.actions;

export default configs.reducer;
